import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@mui/material/Button';
import { connect } from 'react-redux'

import { setMainPanelContent, setViewedStop } from '../../actions/ui'
import i18n from "../../../i18nSetup";

class ViewStopButton extends Component {
  static propTypes = {
    stopId: PropTypes.string,
    text: PropTypes.string
  }

  _onClick = () => {
    this.props.setMainPanelContent(null)
    this.props.setViewedStop({stopId: this.props.stopId})
    this.props.onClick && this.props.onClick();
  }

  render () {
    return (
      <Button
        sx={{paddingTop:2,paddingBottom:2,paddingLeft:0,paddingRight:0,color:'#3399ff',fontSize:12}}
        onClick={this._onClick}
      >{this.props.text || (i18n.t('stopViewer') || 'Stop Viewer')}</Button>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

const mapDispatchToProps = {
  setMainPanelContent,
  setViewedStop
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewStopButton)
